import { UserController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { ResetPassword } from '../../pages';
import { appStore } from '../../stores';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import React from 'react';
import { passwordRegex } from '../../utils/utils';

const ResetPasswordContainer = () => {
	const navigate = useNavigate();

	let password;
	const validationSchema = () =>
		yup.object({
			password: yup
				.string()
				.required('Password is requied')
				.matches(
					passwordRegex,
					'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
				)
				.test('password', '', value => {
					password = value;
					return true;
				}),
			confirmPassword: yup
				.string()
				.required('Confirm Password is required')
				.test(
					'confirmPassword',
					'Confirm Password and Password must be the same value',
					value => value && value === password
				),
		});

	const onSubmit = async values => {
		appStore.setLoading(true);
		const { status, errorMessage } = await UserController.resetPassword({
			newPassword: values.password,
		});
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return navigate(constant.Routes.ResetPasswordChangeSuccess);
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<div>
			<ResetPassword
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={appStore.loading}
			/>
		</div>
	);
};

export default observer(ResetPasswordContainer);
